"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _useScrollPosition = require("./useScrollPosition");
Object.keys(_useScrollPosition).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _useScrollPosition[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useScrollPosition[key];
    }
  });
});